import { useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME, STALE_TIME } from "utils/constants";
import { fetchZonesDD } from "services/dropdown";
import { fetchAllocateZoneById } from "services/allocateZone";
import axiosInstance from "services/axios";

const SettingZoneDropDown = () => {
  const login = useSelector((state) => state.jwtAuthreducer);
  const [zoneId, setZoneId] = useState(localStorage.getItem("zone_id") || null);
  const auth = useSelector((state) => state.jwtAuthreducer);

  // const { data, isLoading, error, refetch } = useQuery(
  //   ["zones"],
  //   () => fetchZonesDD({ ...login }),
  //   {
  //     keepPreviousData: false,
  //     staleTime: DROPDOWN_STALE_TIME
  //   }
  // );

  const { data, isLoading, isError, error, refetch } = useQuery(
    ["fetch-zone-by-id", auth?.user?.employee_code_id],
    () => fetchAllocateZoneById({ employee_code_id: auth?.user?.employee_code_id }),
    {
      staleTime: STALE_TIME,
      enabled: !!auth?.user?.employee_code_id,
    }
  );

  const options =
    data?.data?.map((option) => ({
      value: option?.zone_id,
      label: option?.zone_obj?.zone_name,
    })) || [];

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      localStorage.setItem("zone_id", selectedOption.value);
      if (selectedOption.label) {
        localStorage.setItem("zone_name", selectedOption.label);
      }
      axiosInstance.defaults.headers.common["x-custom-zone-id"] =
        selectedOption.value;
      setZoneId(selectedOption.value);
      window.dispatchEvent(
        new CustomEvent("zoneChanged", { detail: selectedOption.value }),
      );
      window.location.reload(true);
    } else {
      localStorage.removeItem("zone_id");
      localStorage.removeItem("zone_name");
      delete axiosInstance.defaults.headers.common["x-custom-zone-id"];
      setZoneId(null);
      window.dispatchEvent(new CustomEvent("zoneChanged", { detail: null }));
      window.location.reload(false);
    }
  };

  const selectedOption = options.find(
    (option) => Number(option.value) === Number(zoneId),
  );

  if (selectedOption?.label && typeof window !== "undefined") {
    if (!localStorage.getItem("zone_name")) {
      localStorage.setItem("zone_name", selectedOption.label);
    }
  }
  return (
    <div>
      {zoneId && (
        <div
          className="zone-label"
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <span>Already zone exists: </span>
          <strong style={{ marginLeft: "5px" }}>{zoneId}</strong>
        </div>
      )}
      <label className="form-label">Zone</label>
      <Select
        options={options}
        onChange={handleChange}
        placeholder="Select Zone"
        value={selectedOption || null}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          control: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        menuPortalTarget={document.body}
      />
    </div>
  );
};

export default SettingZoneDropDown;
